






































import { isClient } from '~/helpers/check-environment';
import { defineComponent } from '@nuxtjs/composition-api';
import SfChevron from '../SfChevron/SfChevron.vue';
import SfScrollable from '../SfScrollable.vue';
import SfButton from '../SfButton/SfButton.vue';

interface TabConfig {
  tabMaxContentHeight: string;
  tabShowText: string;
  tabHideText: string;
}

export default defineComponent({
  name: 'SfTab',
  components: {
    SfChevron,
    SfScrollable,
    SfButton,
  },
  inject: ['tabConfig'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
      desktopMin: 1024,
    };
  },
  computed: {
    tabMaxContentHeight(this: { tabConfig: TabConfig }) {
      return this.tabConfig.tabMaxContentHeight;
    },
    tabShowText(this: { tabConfig: TabConfig }) {
      return this.tabConfig.tabShowText;
    },
    tabHideText(this: { tabConfig: TabConfig }) {
      return this.tabConfig.tabHideText;
    },
  },
  methods: {
    tabClick() {
      if (!isClient) return;
      const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth,
      );
      if (this.isActive && width > this.desktopMin) return;
      this.$parent.$emit('toggle', this._uid);
    },
  },
});
